import { Box, Typography } from "@mui/material";
import Navbar from "../../../components/Navbar";
import Video from "../../../components/Video";

const Hero = () => {
  return (
    <Box
      pt={{ xs: 18, sm: 24 }}
      pb={{ xs: 2, sm: 6 }}
      px={1}
      boxSizing="border-box"
      justifyContent="end"
      maxWidth={1280}
      mx="auto"
    >
      <Navbar />
      <Box m="auto" data-aos="fade-up">
        <Typography color="#ffffff70" textAlign="center" mt={1}>
          ABOUT US
        </Typography>
        <Typography
          variant={"h2"}
          typography={{ xs: "h2", sm: "h1" }}
          sx={{ fontWeight: "700 !important" }}
          color="#ffffff"
          textAlign="center"
          mt={1}
        >
          OUR STORY
        </Typography>
      </Box>
      <Video path="/videos/about-us" />
    </Box>
  );
};

export default Hero;
